import * as React from "react";

const SmoochLogoSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 47 33"
  >
    <g
      id="001_Homepage"
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
    >
      <g id="z1" fill="#EFC93D" transform="translate(-296 -184)">
        <g id="sunshine_logo_whitewordmark" transform="translate(179 160)">
          <path
            id="Fill-1-Copy"
            d="M161.788 56.67c1.284-2.88 1.994-6.157 1.987-9.51-.027-12.818-10.52-23.187-23.437-23.16-12.916.027-23.365 10.44-23.338 23.257a23 23 0 0 0 2.027 9.414z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default SmoochLogoSVG;
